import DataTableModule from "react-data-table-component";

export const DataTable = DataTableModule.default